import { Audit } from "../../pages";
import React, { useState } from "react";

const AuditContainer = () => {
  const [busAdminTable, setBusAdminTable] = useState(true);
  const [mimaAdminTable, setMimaAdminTable] = useState(false);

  const goToBusAdminTable = () => {
    setBusAdminTable(true);
    setMimaAdminTable(false);
  };

  const goToMimaAdminTable = () => {
    setMimaAdminTable(true);
    setBusAdminTable(false);
  };
  return (
    <Audit
      goToBusAdminTable={goToBusAdminTable}
      goToMimaAdminTable={goToMimaAdminTable}
      busAdminTable={busAdminTable}
      mimaAdminTable={mimaAdminTable}
    />
  );
};

export default AuditContainer;
